import type { Constructor } from '@whispli/types'
import { instanceToPlain } from '@whispli/client/tenant/openapi/utils'

export const withObject = <T extends Constructor>(
  /** The super class to extend */
  SuperClass: T
) => class WithObject extends SuperClass implements WithObject {
  toJSON(options = { groups: [ 'client' ] }) {
    return instanceToPlain<T>(this, options)
  }
}
